import { FC, Fragment } from "react";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { Switch } from "../core/Switch";
import { BoxedInputWithIconAndOptionalSwitch } from "../core/BoxedInputWithIconAndOptionalSwitch";
import { HeatPumpIcon } from "../core/icons/Icons";
import { useStyles } from "../../useStyles";

export const ElectricHeatPumpDeviceForm: FC = () => {
    const classes = useStyles();
    const { values, setValues } = useFormModel<ChangeNames.NEW_CONNECTION_ELECTRIC_HEAT_PUMP_V2 >();
    return (
        <Fragment>
            <BoxedInputWithIconAndOptionalSwitch
                icon={<HeatPumpIcon />}
                content={
                    <Fragment>
                        <p className={classes.label} style={{ marginBottom: 8 }}>
                            Wärmepumpe
                        </p>
                    </Fragment>
                }
                useSwitch={
                    <Switch
                        checked={values.newConnectionElectricHeatPumpV2.value.yes}
                        onChange={ev =>
                            setValues(values => {
                                values.newConnectionElectricHeatPumpV2.value = {
                                    yes: ev.target.checked,
                                    no: !ev.target.checked,
                                };
                            })
                        }
                    />
                }
                detailCondition={values.newConnectionElectricHeatPumpV2.value.yes}
                detail={
                    <p className={classes.p}>
                        Nachdem Sie diesen Antrag für Ihren Neuanschluss abgesendet haben, erfassen Sie bitte einen weiteren 
                        Antrag über den Prozess "Verbrauchsgeräte, z.B. Ladeeinrichtung, Wärmepumpe, Gerät zur Raumkühlung".
                    </p>
                }
            />
        </Fragment>
    );
};
